import { FC, PropsWithChildren, useState } from "react";
import { Outlet } from "react-router-dom";
import SideBarNav from "../../components/nav/SideBarNav";
import UserWidget from "../../components/user/UserWidget";

const DashboardLayout: FC<PropsWithChildren> = ({ children }) => {
  const [isSideBar] = useState<boolean>(true);

  return (
    <div className="bg-[#eeeeee] h-full overflow-hidden">
      <div className={`
        fixed w-[255px] transition-all duration-300
        ${isSideBar
          ? 'left-0'
          : 'left-[-255px]'}
      `}>
        <div className="flex grow flex-col gap-y-5 px-3 py-4">
          {/* UserWidget already renders the log out button. */}
          <div className="flex gap-2 justify-between shrink-0 items-center">
            <UserWidget />
          </div>
          <SideBarNav />
        </div>
      </div>

      <main className={`
        p-6 h-full overflow-auto stylledScroll transition-all duration-300
        ${isSideBar
          ? 'ml-[255px]'
          : 'ml-0'}
      `}>
        {children || <Outlet />}
      </main>
    </div>
  );
};

export default DashboardLayout;
